<div class="upload-dialog" mat-dialog-content>
  <div class="hero">
    <p class="eyebrow">Receipt Upload</p>
    <h2>Drop receipts into the queue</h2>
    <p class="subtitle">Files upload straight into the unsorted receipts list. PDFs and images are both accepted.</p>
  </div>

  <div class="stats">
    <span class="pill ghost">{{ files.length }} queued</span>
    <span class="pill success" *ngIf="completedCount">{{ completedCount }} uploaded</span>
    <span class="pill danger" *ngIf="failedCount">{{ failedCount }} failed</span>
    <span class="pill soft" *ngIf="uploading">Uploading now</span>
  </div>

  <ngx-dropzone class="dropzone" (change)="onSelect($event)" accept="image/*,application/pdf">
    <ngx-dropzone-label>
      <div class="dropzone-label">
        <mat-icon>upload_file</mat-icon>
        <div>
          <div class="title">Drop receipt files here</div>
          <div class="subtitle">Or click to browse from disk.</div>
        </div>
      </div>
    </ngx-dropzone-label>
  </ngx-dropzone>

  <div class="queue" *ngIf="files.length; else emptyState">
    <div class="queue-item" *ngFor="let item of files">
      <div class="file-meta">
        <div class="name">{{ item.file.name }}</div>
        <div class="subtext">{{ (item.file.size / 1024 / 1024).toFixed(2) }} MB</div>
        <div class="error" *ngIf="item.error">{{ item.error }}</div>
      </div>

      <div class="file-actions">
        <span class="status-pill" [ngClass]="item.state">{{ item.state }}</span>
        <button mat-icon-button *ngIf="item.state !== 'uploading'" (click)="removeFile(item)" aria-label="Remove file">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <mat-icon>receipt_long</mat-icon>
      <p>No files added yet.</p>
    </div>
  </ng-template>
</div>

<div mat-dialog-actions align="end">
  <button mat-button *ngIf="failedCount" (click)="retryFailed()">Retry Failed</button>
  <button mat-raised-button color="primary" (click)="close()">Done</button>
</div>
